// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-advanced-dlp-monitoring.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-advanced-dlp-monitoring',
  title: 'Implement advanced DLP monitoring: detect, block and alert on sensitive data flows',
  description:
    'When processing critical business information or sensitive personal data, monitoring tools must be configured to: detect sensitive data being disclosed during processing or transmission; block user actions or network transmissions that expose sensitive data; and notify or alert on activities that violate data handling policies. Monitoring policies must define what data can flow, to whom, how and where.',
  category: 'technical',
  scfIds: ['SCF-DAT-003', 'SCF-OPS-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Advanced DLP monitoring configuration and policy is documented',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
